/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";

@Injectable({
    providedIn: "root",
})
export class SimStreamService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public getAudio_Url(scenarioRecordingId: string, scenarioRecordingSceneIndex: number) {
        return super.getUrl(`/api/stream/audio-file/${encodeURIComponent(scenarioRecordingId)}/${encodeURIComponent(scenarioRecordingSceneIndex)}`, );
    }

    public getAudio_1_Url(scenarioRecordingId: string, scenarioRecordingSceneIndex: number, channelIndex: number) {
        return super.getUrl(`/api/stream/audio-file/${encodeURIComponent(scenarioRecordingId)}/${encodeURIComponent(scenarioRecordingSceneIndex)}/${encodeURIComponent(channelIndex)}`, );
    }

    public getInternalStreamingAudioFile_Url(fileSetId: string, audioChannelId: string) {
        return super.getUrl(`/api/stream/internal-streaming-audio-file/${encodeURIComponent(fileSetId)}/${encodeURIComponent(audioChannelId)}`, );
    }

    public getMedia_Url(mediaId: string, size: string = null, h: number = null, w: number = null) {
        return super.getUrl(`/api/media/media-file/${encodeURIComponent(mediaId)}`, {size: size, h: h, w: w});
    }

    public getPoster_Url(scenarioRecordingId: string, scenarioRecordingSceneIndex: number, videoFileIndex: number) {
        return super.getUrl(`/api/poster/video-file/${encodeURIComponent(scenarioRecordingId)}/${encodeURIComponent(scenarioRecordingSceneIndex)}/${encodeURIComponent(videoFileIndex)}`, );
    }

    public getVideo_Url(scenarioRecordingId: string, scenarioRecordingSceneIndex: number, videoFileIndex: number) {
        return super.getUrl(`/api/stream/video-file/${encodeURIComponent(scenarioRecordingId)}/${encodeURIComponent(scenarioRecordingSceneIndex)}/${encodeURIComponent(videoFileIndex)}`, );
    }
}